import { createSelector } from 'reselect'
import {allPlatforms} from '../helpers/helpers';

const selectedCoin  = state => state.ui.selectedCoin
const coins = state => state.coins

// shows for the currently selected coin, data from which platforms is present
// maybe its just reddit, reddit_a and telegram - and rest missing
const getPlatformsOfCoin = (selectedCoin, coins) => {

  const coinObj = coins.find(c => c.id === selectedCoin)
  if(!coinObj) return []

  const platforms = {}
  allPlatforms.forEach(plat => coinObj[plat] && (platforms[plat] = 1))
  if(platforms['reddit']) platforms['reddit_a'] = 1 // if reddit is present -> set reddit_a to true aswell
  if(platforms['discord']) platforms['discord_a'] = 1 // if discord is present -> set discord_a to true aswell
  if(platforms['telegram']) platforms['telegram_a'] = 1 // if discord is present -> set discord_a to true aswell
  if(coinObj.searchName !== '-') platforms['reddit_m'] = 1 // if searchName is '-', it means no reddit-mentions ( coin name is to general )
  if(coinObj.searchName !== '-') platforms['reddit_ms'] = 1 // if searchName is '-', it means no reddit-mentions ( coin name is to general )
  return platforms
}

export default createSelector([selectedCoin, coins], getPlatformsOfCoin)



// WEBPACK FOOTER //
// ./src/selectors/platformsOfCoin.js